module.exports = __webpack_public_path__ + "fonts/bariol-bold.2707d29d.woff";